export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        access: "menu"
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        icon: "uil-home-alt",
        link: "/",
        access: "dashboard"
    },
    {
        id: 6,
        label: "menuitems.customers.text",
        icon: "uil-users-alt",
        access: "customers",
        subItems: [
            {
                id: 7,
                label: "menuitems.customers.list.users",
                link: "/customers",
                parentId: 6
            },
        ]
    },
    {
        id: 101,
        label: "menuitems.teams.text",
        icon: "uil-football",
        access: "teams",
        subItems: [
            {
                id: 102,
                label: "menuitems.teams.list.list",
                link: "/teams/list",
                parentId: 101,
                access: "teams_list",
            },
            {
                id: 103,
                label: "menuitems.teams.list.squad",
                link: "/teams/squad",
                parentId: 101
            },
        ]
    },
    {
        id: 110,
        label: "menuitems.fixtures.text",
        icon: "uil-calendar-alt",
        access: "fixtures",
        subItems: [
            {
                id: 111,
                label: "menuitems.fixtures.list.feature_matches",
                link: "/fixtures/featured_matches",
                parentId: 110
            },
            {
                id: 112,
                label: "menuitems.fixtures.list.rounds",
                link: "/fixtures/rounds",
                parentId: 110
            },
            {
                id: 113,
                label: "menuitems.fixtures.list.standings",
                link: "/fixtures/standings",
                parentId: 110
            },
        ]
    },
    {
        id: 120,
        label: "menuitems.news.text",
        icon: "uil-rss",
        access: "news",
        subItems: [
            {
                id: 121,
                label: "menuitems.news.list.videos",
                link: "/news/videos",
                parentId: 120
            },
            {
                id: 122,
                label: "menuitems.news.list.feed",
                link: "/news/feed",
                parentId: 120
            },
            {
                id: 123,
                label: "menuitems.news.list.statistics",
                link: "/news/statistics",
                parentId: 120
            },
        ]
    },
    {
        id: 130,
        label: "menuitems.ticketing.text",
        icon: "uil-ticket",
        access: "ticketing",
        subItems: [
            {
                id: 131,
                label: "menuitems.ticketing.list.tickets",
                link: "/ticketing/tickets",
                parentId: 130
            },
        ]
    },
    {
        id: 140,
        label: "menuitems.games.text",
        icon: "uil-smile",
        access: "games",
        subItems: [
            // {
            //     id: 141,
            //     label: "menuitems.games.list.ptw",
            //     link: "/games/player_of_the_week",
            //     parentId: 140
            // },
            {
                id: 142,
                label: "menuitems.games.list.gts",
                link: "/games/guess_the_score",
                parentId: 140
            },
            {
                id: 143,
                label: "menuitems.games.list.motm",
                link: "/games/man_of_the_match",
                parentId: 140
            },
        ]
    },
    {
        id: 150,
        label: "menuitems.advertising.text",
        icon: "uil-file-contract-dollar",
        access: "advertising",
        subItems: [
            {
                id: 151,
                label: "menuitems.advertising.list.banner",
                link: "/advertising/banner",
                parentId: 150
            },
            {
                id: 152,
                label: "menuitems.advertising.list.advertorial",
                link: "/advertising/advertorial",
                parentId: 150
            },
            {
                id: 153,
                label: "menuitems.advertising.list.sponsors",
                link: "/advertising/sponsors",
                parentId: 150
            },
            {
                id: 153,
                label: "menuitems.advertising.list.player",
                link: "/advertising/player",
                parentId: 150
            },
            {
                id: 154,
                label: "menuitems.advertising.list.wall",
                link: "/advertising/wall",
                parentId: 150
            },
            
        ]
    },
    {
        id: 160,
        label: "menuitems.notifications.text",
        icon: "uil-message",
        link: "/notifications",
        access: "notifications",
    },
    {
        id: 170,
        label: "menuitems.orders.text",
        icon: "uil-store",
        link: "/orders",
        access: "orders",
    },

    //only for monitoring
    {
        id: 180,
        label: "menuitems.monitor.text",
        icon: "uil-home-alt",
        access: "monitor",
        subItems: [
            {
                id: 171,
                label: "menuitems.monitor.list.queues",
                link: "/monitor/queues",
                parentId: 180
            },
        ]
    },

    
  /*
    
    {
        id: 3,
        label: "menuitems.apps.text",
        isTitle: true,
        access: "template",
    },
    {
        id: 4,
        label: "menuitems.calendar.text",
        icon: "uil-calender",
        link: "/calendar",
        access: "template",
    },
    {
        id: 5,
        label: "menuitems.chat.text",
        icon: "uil-comments-alt",
        link: "/chat",
        access: "template",
        badge: {
            variant: "warning",
            text: "menuitems.chat.badge"
        }
    },
    {
        id: 100,
        label: "menuitems.ecommerce.text",
        icon: "uil-store",
        access: "template",
        subItems: [
            {
                id: 7,
                label: "menuitems.ecommerce.list.products",
                link: "/ecommerce/products",
                parentId: 6
            },
            {
                id: 8,
                label: "menuitems.ecommerce.list.productdetail",
                link: "/ecommerce/product-detail/1",
                parentId: 6
            },
            {
                id: 9,
                label: "menuitems.ecommerce.list.orders",
                link: "/ecommerce/orders",
                parentId: 6
            },
            {
                id: 10,
                label: "menuitems.ecommerce.list.customers",
                link: "/ecommerce/customers",
                parentId: 6
            },
            {
                id: 11,
                label: "menuitems.ecommerce.list.cart",
                link: "/ecommerce/cart",
                parentId: 6
            },
            {
                id: 12,
                label: "menuitems.ecommerce.list.checkout",
                link: "/ecommerce/checkout",
                parentId: 6
            },
            {
                id: 13,
                label: "menuitems.ecommerce.list.shops",
                link: "/ecommerce/shops",
                parentId: 6
            },
            {
                id: 14,
                label: "menuitems.ecommerce.list.addproduct",
                link: "/ecommerce/add-product",
                parentId: 6
            }
        ]
    },
    {
        id: 15,
        label: "menuitems.email.text",
        icon: "uil-envelope",
        access: "template",
        subItems: [
            {
                id: 16,
                label: "menuitems.email.list.inbox",
                link: "/email/inbox",
                parentId: 15
            },
            {
                id: 17,
                label: "menuitems.email.list.reademail",
                link: "/email/reademail/1",
                parentId: 15
            }
        ]
    },
    {
        id: 18,
        label: "menuitems.invoices.text",
        icon: "uil-invoice",
        access: "template",
        subItems: [
            {
                id: 19,
                label: "menuitems.invoices.list.invoicelist",
                link: "/invoices/list",
                parentId: 18
            },
            {
                id: 20,
                label: "menuitems.invoices.list.invoicedetail",
                link: "/invoices/detail",
                parentId: 18
            }
        ]
    },
    
   
    {
        id: 25,
        label: "menuitems.pages.text",
        isTitle: true,
        access: "template",
    },
    
    {
        id: 26,
        label: "menuitems.authentication.text",
        icon: "uil-user-circle",
        access: "template",
        subItems: [
            {
                id: 27,
                label: "menuitems.authentication.list.login",
                link: "/auth/login-1",
                parentId: 26
            },
            {
                id: 28,
                label: "menuitems.authentication.list.register",
                link: "/auth/register-1",
                parentId: 26
            },
            {
                id: 29,
                label: "menuitems.authentication.list.recoverpwd",
                link: "/auth/recoverpwd",
                parentId: 26
            },
            {
                id: 30,
                label: "menuitems.authentication.list.lockscreen",
                link: "/auth/lock-screen",
                parentId: 26
            }
        ]
    },
    {
        id: 31,
        label: "menuitems.utility.text",
        icon: "uil-file-alt",
        access: "template"
        subItems: [
            {
                id: 32,
                label: "menuitems.utility.list.starter",
                link: "/utility/starter",
                parentId: 31
            },
            {
                id: 33,
                label: "menuitems.utility.list.maintenance",
                link: "/utility/maintenance",
                parentId: 31
            },
            {
                id: 35,
                label: "menuitems.utility.list.comingsoon",
                link: "/utility/comingsoon",
                parentId: 31
            },
            {
                id: 36,
                label: "menuitems.utility.list.timeline",
                link: "/utility/timeline",
                parentId: 31
            },
            {
                id: 37,
                label: "menuitems.utility.list.faqs",
                link: "/utility/faqs",
                parentId: 31
            },
            {
                id: 38,
                label: "menuitems.utility.list.pricing",
                link: "/utility/pricing",
                parentId: 31
            },
            {
                id: 39,
                label: "menuitems.utility.list.error404",
                link: "/utility/404",
                parentId: 31
            },
            {
                id: 40,
                label: "menuitems.utility.list.error500",
                link: "/utility/500",
                parentId: 31
            }
        ]
    },
    {
        id: 41,
        label: "menuitems.components.text",
        isTitle: true,
        access: "template",
    },
    {
        id: 42,
        label: "menuitems.uielements.text",
        icon: "uil-flask",
        subItems: [
            {
                id: 43,
                label: "menuitems.uielements.list.alerts",
                link: "/ui/alerts",
                parentId: 42
            },
            {
                id: 44,
                label: "menuitems.uielements.list.buttons",
                link: "/ui/buttons",
                parentId: 42
            },
            {
                id: 45,
                label: "menuitems.uielements.list.cards",
                link: "/ui/cards",
                parentId: 42
            },
            {
                id: 46,
                label: "menuitems.uielements.list.carousel",
                link: "/ui/carousel",
                parentId: 42
            },
            {
                id: 47,
                label: "menuitems.uielements.list.dropdowns",
                link: "/ui/dropdown",
                parentId: 42
            },
            {
                id: 48,
                label: "menuitems.uielements.list.grid",
                link: "/ui/grid",
                parentId: 42
            },
            {
                id: 49,
                label: "menuitems.uielements.list.images",
                link: "/ui/images",
                parentId: 42
            },
            {
                id: 50,
                label: "menuitems.uielements.list.lightbox",
                link: "/ui/lightbox",
                parentId: 42
            },
            {
                id: 51,
                label: "menuitems.uielements.list.modals",
                link: "/ui/modals",
                parentId: 42
            },
            {
                id: 52,
                label: "menuitems.uielements.list.rangeslider",
                link: "/ui/rangeslider",
                parentId: 42
            },
            {
                id: 53,
                label: "menuitems.uielements.list.progressbar",
                link: "/ui/progressbar",
                parentId: 42
            },
            {
                id: 53,
                label: "menuitems.uielements.list.placeholder",
                link: "/ui/placeholder",
                parentId: 42
            },
            {
                id: 54,
                label: "menuitems.uielements.list.sweetalert",
                link: "/ui/sweet-alert",
                parentId: 42
            },
            {
                id: 55,
                label: "menuitems.uielements.list.tabs",
                link: "/ui/tabs-accordions",
                parentId: 42
            },
            {
                id: 56,
                label: "menuitems.uielements.list.typography",
                link: "/ui/typography",
                parentId: 42
            },
            {
                id: 57,
                label: "menuitems.uielements.list.video",
                link: "/ui/video",
                parentId: 42
            },
            {
                id: 58,
                label: "menuitems.uielements.list.general",
                link: "/ui/general",
                parentId: 42
            },
            {
                id: 59,
                label: "menuitems.uielements.list.colors",
                link: "/ui/colors",
                parentId: 42
            },
            {
                id: 60,
                label: "menuitems.uielements.list.rating",
                link: "/ui/rating",
                parentId: 42
            }
        ]
    },
    {
        id: 62,
        label: "menuitems.forms.text",
        icon: "uil-shutter-alt",
        access: "template",
        badge: {
            variant: "danger",
            text: 'menuitems.forms.badge'
        },
        subItems: [
            {
                id: 63,
                label: "menuitems.forms.list.elements",
                link: "/form/elements",
                parentId: 62
            },
            {
                id: 64,
                label: "menuitems.forms.list.validation",
                link: "/form/validation",
                parentId: 62
            },
            {
                id: 65,
                label: "menuitems.forms.list.advanced",
                link: "/form/advanced",
                parentId: 62
            },
            {
                id: 66,
                label: "menuitems.forms.list.editor",
                link: "/form/editor",
                parentId: 62
            },
            {
                id: 67,
                label: "menuitems.forms.list.fileupload",
                link: "/form/upload",
                parentId: 62
            },
            {
                id: 68,
                label: "menuitems.forms.list.repeater",
                link: "/form/repeater",
                parentId: 62
            },
            {
                id: 69,
                label: "menuitems.forms.list.wizard",
                link: "/form/wizard",
                parentId: 62
            },
            {
                id: 70,
                label: "menuitems.forms.list.mask",
                link: "/form/mask",
                parentId: 62
            }
        ]
    },
    {
        id: 71,
        icon: "uil-list-ul",
        label: "menuitems.tables.text",
        access: "template",
        subItems: [
            {
                id: 72,
                label: "menuitems.tables.list.basic",
                link: "/tables/basic",
                parentId: 71
            },
            {
                id: 73,
                label: "menuitems.tables.list.advanced",
                link: "/tables/advanced",
                parentId: 71
            }
        ]
    },
    {
        id: 74,
        icon: "uil-chart",
        label: "menuitems.charts.text",
        access: "template",
        subItems: [
            {
                id: 75,
                label: "menuitems.charts.list.apex",
                link: "/charts/apex",
                parentId: 74
            },
            {
                id: 76,
                label: "menuitems.charts.list.chartjs",
                link: "/charts/chartjs",
                parentId: 74
            },
            {
                id: 77,
                label: "menuitems.charts.list.chartist",
                link: "/charts/chartist",
                parentId: 74
            },
            {
                id: 78,
                label: "menuitems.charts.list.echart",
                link: "/charts/echart",
                parentId: 74
            }
        ]
    },
    {
        id: 79,
        label: "menuitems.icons.text",
        icon: "uil-streering",
        access: "template",
        subItems: [
            {
                id: 80,
                label: "menuitems.icons.list.unicons",
                link: "/icons/unicons",
                parentId: 79
            },
            {
                id: 81,
                label: "menuitems.icons.list.boxicons",
                link: "/icons/boxicons",
                parentId: 79
            },
            {
                id: 82,
                label: "menuitems.icons.list.materialdesign",
                link: "/icons/materialdesign",
                parentId: 79
            },
            {
                id: 83,
                label: "menuitems.icons.list.dripicons",
                link: "/icons/dripicons",
                parentId: 79
            },
            {
                id: 84,
                label: "menuitems.icons.list.fontawesome",
                link: "/icons/fontawesome",
                parentId: 79
            }
        ]
    },
    {
        id: 85,
        label: "menuitems.maps.text",
        icon: "uil-location-point",
        access: "template",
        subItems: [
            {
                id: 86,
                label: "menuitems.maps.list.googlemap",
                link: "/maps/google",
                parentId: 85
            },
            {
                id: 87,
                label: "menuitems.maps.list.leafletmap",
                link: "/maps/leaflet",
                parentId: 85
            },
        ]
    },
    {
        id: 88,
        label: "menuitems.multilevel.text",
        icon: "uil-share-alt",
        access: "template",
        subItems: [
            {
                id: 89,
                label: "menuitems.multilevel.list.level1.1",
                link: "#",
                parentId: 88
            },
            {
                id: 90,
                label: "menuitems.multilevel.list.level1.2",
                parentId: 88,
                subItems: [
                    {
                        id: 91,
                        label: "menuitems.multilevel.list.level1.level2.1",
                        link: "#",
                        parentId: 88
                    },
                    {
                        id: 92,
                        label: "menuitems.multilevel.list.level1.level2.2",
                        link: "#",
                        parentId: 88
                    }
                ]
            }
        ]
    }
    
    */
    
    
];

